import { createTheme } from '../utils';
import * as ModalHeading from './components/ModalHeading.css';

export const defaultTheme = {
	ModalHeading
};

export const { useTheme, Provider } = createTheme<typeof defaultTheme>(defaultTheme);
